import React from 'react'
import classNames from 'classnames'
import CSSModules from 'react-css-modules'
import { Progress } from '@/components'
// 样式
import style from './ProductListItem.module.scss'
import cursorPic from '@/pages/product/images/cursor-bg.png'
import { sniff } from '@/util'
import { LaunchApp, ImageAvatar } from '@/components'
import { openurlConfig } from '@/config'

/**
 * 自选球队和选组随机 和阶梯价格产品显示起
 *
 * @param {*} 产品信息
 * @return {*} Boolean
 */
export const randomPrice = (product = {}) => {
  // 自选球队和选组随机(卡种区分编号)
  const customTeamProduct = (product.teamup_type === 'custom_team' || product.teamup_type === 'random_group_with_number') && product.remain_checklist_assign_enable === false
  // 阶梯价
  const tieredPrice = product.min_price
  return customTeamProduct || tieredPrice
}

const ProductListItem = props => {
  const { item, category, itemCallback, goShop } = props
  const handlePriceStyle = price => {
    let resultArr = []
    // const priceString = price.toString()
    const priceString = item?.min_price ? item?.min_price.toString() : `${price}`.toString()
    if (priceString.includes('.')) {
      resultArr = priceString.toString().split('.')
    } else {
      resultArr.push(price)
    }
    return (
      <div styleName="product-price">
        {price && <span styleName="price-unit">￥</span>}
        {resultArr.map((item, index) => {
          return (
            <span key={index}
                styleName={classNames(index === 0 ? 'num-integer' : 'num-decimals')}>
              {index === 1 ? '.' + item : item}
            </span>
          )
        })}
        {randomPrice(item) && <span styleName="price-text"> 起</span>}
      </div>
    )
  }

  const progress = () => {
    return (
      <div styleName="product-process">
        <Progress
            barColor="linear-gradient(90deg, #F16974 0%, #FA541C 100%)"
            cursorStyle={{
            width: '3.733vw',
            height: '3.733vw',
            backgroundImage: `url(${cursorPic})`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'contain',
          }}
            percentage={Number(item?.progress?.percent)}
          // percentage={((item.total_stock - item.available_stock) / item.total_stock) * 100}
            trackColor="#F4AAAE"
        ></Progress>
      </div>
    )
  }
  const typeRender = arr => {
    return (
      <div styleName="item-type">
        {arr.map((item, index) => {
          return <span key={index}>{`${item}${index === arr.length - 1 ? '' : ' | '}`}</span>
        })}
      </div>
    )
  }

  const fansBoxAppUrl = (type) => {
    if(!type) return
    // 范盒 box boxDetail: '/pages/fansbox/fansbox'
    // 范盒福袋 bagDetail: '/pages/fansbox/detail-bag'
    // 范盒标品 normalDetail: '/pages/fansbox/detail-normal'
    switch(type) {
      case 'normal':
        return openurlConfig.normalDetail
      case 'bag':
        return openurlConfig.bagDetail
      case 'box':
        return openurlConfig.boxDetail
    }
  }

  const getItem = () => {
    console.log(item, 'item')
    const { theme = 'light', titleKey = 'title' } = props
    let flag = category
    if (category == 'mixed') {
      flag = item.product_type == 'fansbox' ? 'fansbox' : 'breaking'
    }
    switch (flag) {
      case 'breaking':
        return (
          <div styleName={`item theme_${theme}`}>
            <div styleName="shop-info">
              <div styleName="shop-info-lf">
                {/* <img alt="商家店铺logo"
                    src={item.merchant?.logo?.thumb_square}
                    styleName="shop-icon" /> */}
                <div styleName="shop-icon">
                  <ImageAvatar alt={'商家店铺logo'}
                      avatarUrl={item.merchant?.logo?.thumb_square} />
                </div>
                <div className="shop-name">{item.merchant_name || ''}</div>
              </div>
              {sniff.isUboxApp && (
                <div
                    onClick={() => {
                    goShop(item.merchant?.id || '')
                  }}
                    styleName="shop-info-rt"
                >
                  <span>进店</span>
                  <span styleName="goto-shop"></span>
                </div>
              )}
              {!sniff.isUboxApp && (
                <LaunchApp fixed={false}
                    openUrl={`${openurlConfig.merchant}?id=${item.merchant?.id}`}>
                  <div styleName="shop-info-rt">
                    <span>进店</span>
                    <span styleName="goto-shop"></span>
                  </div>
                </LaunchApp>
              )}
            </div>
            <div
                onClick={() => {
                if (sniff.isUboxApp) {
                  itemCallback(item.id, 'breaking')
                }
              }}
            >
              <LaunchApp fixed={false}
                  openUrl={`${openurlConfig.breakingDetail}?id=${item.id}`}>
                <div styleName="good-info">
                  <div styleName="item-pic">
                    <img src={item.cover_image && item.cover_image.thumb_o}
                        styleName="pic" />
                  </div>
                  <div styleName="item-content">
                    <div styleName="item-title">
                      {item.tag ? <span styleName="item-title_tag">{`${item.tag}`}</span> : null}
                      <span styleName="item-title_text">{item[titleKey]}</span>
                    </div>
                    {typeRender(item.product_meta_text_arr || [])}
                    <div>{progress()}</div>
                    <div styleName="item-info">
                      {item.price_text ? item.price_text : handlePriceStyle(item.price)}
                      <div styleName="stock-text">{item.stock_text}</div>
                    </div>
                  </div>
                </div>
              </LaunchApp>
            </div>
          </div>
        )
      case 'fansbox':
        return (
          <div styleName={`item theme_${theme}`}>
            <div
                onClick={() => {
                if (sniff.isUboxApp) {
                  itemCallback(item.id, 'fansbox', fansBoxAppUrl(item.type))
                }
              }}
            >
              <LaunchApp fixed={false}
                  openUrl={`${fansBoxAppUrl(item.type)}?id=${item.id}`}>
                <div styleName="good-info">
                  <div styleName="item-pic">
                    <img src={item.cover_image && item.cover_image.thumb_o}
                        styleName="pic" />
                  </div>
                  <div styleName="item-content">
                    <div styleName="item-title">
                      {item.tag ? <span styleName="item-title_tag">{`${item.tag}`}</span> : null}
                      <span styleName="item-title_text">{item[titleKey]}</span>
                    </div>
                    {typeRender(item.product_meta_text_arr || [])}
                    <div style={{visibility:item.type == 'normal' ? 'hidden' : 'visible'}}>{progress()}</div>
                    <div styleName="item-info">
                      {item.price_text ? item.price_text : handlePriceStyle(item.price)}
                      <div styleName="stock-text">{item.stock_text}</div>
                    </div>
                  </div>
                </div>
              </LaunchApp>
            </div>
            <div style={{ marginTop: 5 }}
                styleName="shop-info">
              <div styleName="shop-info-lf">
                {/* <img alt="商家店铺logo"
                      src={item.merchant?.logo?.thumb_square}
                      styleName="shop-icon" /> */}
                <div styleName="shop-icon">
                  <ImageAvatar alt={'商家店铺logo'}
                      avatarUrl={item.merchant?.logo?.thumb_square} />
                </div>
                <div className="shop-name">{item.merchant?.name || ''}</div>
              </div>
            </div>
          </div>
        )
      default:
        return null
    }
  }

  return <>{getItem()}</>
}

export default CSSModules(ProductListItem, style, { allowMultiple: true })
